<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';
import router from '@/routes/router';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/folios`;
const token = utilsService.getToken();

const folioService = {
  async get(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al crear el folio.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },

  async getValidaFolio(id) {
    try {
      const response = await axios.get(`${apiUrl}/valida-folio/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      
      return response.data;
    } catch (error) {
      return false;
    }
  },

  async getAll() {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async create(formRaw) {
    try {
      const form = { ...formRaw };
      const response = await axios.post(`${apiUrl}/create`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al crear la folio.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },

  async update(formRaw, id) {
    try {
      const form = { ...formRaw };

      const response = await axios.put(`${apiUrl}/${id}`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      console.error('Error al enviar el formulario', error);
    }
  },

  async deleteBy(id) {
    try {
      const response = await axios.delete(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async getFolioValido() {
    try {
      const response = await axios.get(`${apiUrl}/get-folio-valido`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      
      return response.data;
    } catch (error) {
      return 0;
    }
  },
  async getAllFiltered(formRaw) {
    try {
      const form = { ...formRaw };
      const response = await axios.post(`${apiUrl}/filtered`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },
};

export default folioService;
</script>
